// extracted by mini-css-extract-plugin
module.exports = {"container":"ActionsDropdown_container__1UbYM","trigger":"ActionsDropdown_trigger__kfvbc"};